import { SpinboxAddToCart } from 'components/Blocks/Product/AddToCart/SpinboxAddToCart';
import { ProductStock } from 'components/Blocks/Product/Availability/ProductStock';
import { Item, ItemProps, TEST_IDENTIFIER } from 'components/Blocks/Product/CategoryPromotedProducts/Item/Item';
import { ProductLink } from 'components/Blocks/Product/CategoryPromotedProducts/Item/ProductLink';
import { B2bProductPrice } from 'components/Blocks/Product/Price/B2bProductPrice';

export const B2bItem: FC<ItemProps> = ({ item, gtmListName, listIndex }) => {
    return (
        <Item item={item}>
            <div className="mr-2 flex flex-1 items-center text-center text-small font-bold">
                <div className="w-3/5 pr-3 text-left" data-testid={TEST_IDENTIFIER + 'name'}>
                    <ProductLink item={item} gtmListName={gtmListName} listIndex={listIndex} />
                </div>

                <div className="mr-2 block w-2/5 text-left">
                    <ProductStock
                        quantity={item.stockQuantity}
                        minimumSellingQuantity={item.b2bMinimumProductOrder ?? 1}
                    />
                </div>
            </div>

            <div className="block w-40 items-center justify-end text-right">
                <B2bProductPrice
                    b2bPaymentDiscount={item.b2bPaymentDiscount}
                    isUnitPrice={(item.b2bMinimumProductOrder ?? 0) > 1}
                    sellingPrice={item.price}
                    basePrice={item.prices.basic}
                    variant="narrow"
                />
            </div>

            <div className="ml-4 w-40">
                <SpinboxAddToCart
                    spinboxIdSuffix="-promoted"
                    product={item}
                    gtmListName={gtmListName}
                    listIndex={listIndex}
                    variant="iconOnly"
                />
            </div>
        </Item>
    );
};
